import { LocationDescriptor } from 'react-router';
import { useContext } from 'react';
import { ReactRouterContext } from '../components';

function useLocation(): LocationDescriptor {
    const { location } = useContext(ReactRouterContext);

    return location;
}

export default useLocation;
